/* eslint-disable @typescript-eslint/camelcase */
import * as React from 'react'
import { Helmet } from 'react-helmet'
import {useTranslation} from 'react-i18next'
import {Redirect, Route, Router, Switch} from 'react-router'
import { Notification } from './components/notification'
import Footer from './components/footer'
import './css/common.css'
import About from './pages/about'
import Contact from './pages/contact'
import ForgotPassword from './pages/forgotPassword'
import GDPR from './pages/gdpr'
import GetInTouch from './pages/getInTouch'
import GhostCompletions from './pages/ghostCompletions'
import Landing from './pages/landing'
import Login from './pages/login'
import MarketResearch from './pages/marketResearch'
import Monetization from './pages/monetization'
import MRContact from './pages/mrContact'
import PrivacyDsp from './pages/privacyDsp'
import PrivacyPolicy from './pages/privacyPolicy'
import PrivacySdk from './pages/privacySdk'
import Register from './pages/register'
import Restored from './pages/restored'
import RTB from './pages/rtb'
import Security from './pages/security'
import TermsUse from './pages/termsUse'
import Welcome from './pages/welcome'
import ContextDistanceCalculator from './pages/contextDistanceCalculator'
import AppProps from './util/appProps'
import {getFont, isSimplePage} from './util/util'
import { availableLocales, getCurrentLocale } from './util/locales'
import { useRef } from 'react'


const baseLocaleUrl = `/:locale(${availableLocales.join('|')})`

const routes = Object.freeze({
    white_papersGhost_completes_mr_05_2020: '/white_papers/ghost_completes_mr_05_2020',
    marketResearch: '/market-research',
    forgot_password: '/forgot_password',
    privacy_policy: '/privacy_policy',
    monetization: '/monetization',
    privacy_dsp: '/privacy_dsp',
    privacy_sdk: '/privacy_sdk',
    welcomeBack: '/welcomeBack',
    getInTouch: '/getInTouch',
    mrcontact: '/mrcontact',
    terms_use: '/terms_use',
    security: '/security',
    restored: '/restored',
    sign_up: '/sign_up',
    welcome: '/welcome',
    contact: '/contact',
    about: '/about',
    login: '/login',
    gdpr: '/gdpr',
    rtb: '/rtb',
    contextDistanceCalculator: '/context-distance-calculator',
})

const PageContent = (props: AppProps) => {
    const {i18n} = useTranslation('landing')
    const simple = isSimplePage(props.location.pathname)
    
    const lastLocaleRef = useRef(getCurrentLocale())

    const path = props.location.pathname
    const currentLocale = '/' + (getCurrentLocale('dontPassDefaultEn') || lastLocaleRef.current)
    const pathWithoutLocale = path.replace(currentLocale, '')
    const isPathValid = Object.values(routes).some((route) => pathWithoutLocale.startsWith(route))

    if (getCurrentLocale('dontPassDefaultEn')) {
      lastLocaleRef.current = getCurrentLocale('dontPassDefaultEn')
    }

    const redirectTo = isPathValid ? pathWithoutLocale + props.location.search + props.location.hash : ''

    return (
        <div className={'page-content' + (simple ? ' simple-bg' : '')} style={getFont(i18n)}>
            <Helmet htmlAttributes={{lang: getCurrentLocale()}}>
                {availableLocales.map(locale => {
                    if (currentLocale.includes(locale)) return
                    return <link key={locale} rel="alternate" hrefLang={locale} href={`/${locale}${redirectTo}`} />
                })}
            </Helmet>

            <Router history={props.history}>
                <Switch>
                    <Route exact path={baseLocaleUrl} component={Landing} />
                    <Route path={baseLocaleUrl + routes.white_papersGhost_completes_mr_05_2020} component={GhostCompletions} />
                    <Route path={baseLocaleUrl + routes.marketResearch} component={MarketResearch} />
                    <Route path={baseLocaleUrl + routes.forgot_password} component={ForgotPassword} />
                    <Route path={baseLocaleUrl + routes.privacy_policy} component={PrivacyPolicy} />
                    <Route path={baseLocaleUrl + routes.monetization} component={Monetization} />
                    <Route path={baseLocaleUrl + routes.privacy_dsp} component={PrivacyDsp} />
                    <Route path={baseLocaleUrl + routes.privacy_sdk} component={PrivacySdk} />
                    <Route path={baseLocaleUrl + routes.welcomeBack} component={Welcome} />
                    <Route path={baseLocaleUrl + routes.getInTouch} component={GetInTouch} />
                    <Route path={baseLocaleUrl + routes.mrcontact} component={MRContact} />
                    <Route path={baseLocaleUrl + routes.terms_use} component={TermsUse} />
                    <Route path={baseLocaleUrl + routes.security} component={Security} />
                    <Route path={baseLocaleUrl + routes.restored} component={Restored} />
                    <Route path={baseLocaleUrl + routes.sign_up} component={Register} />
                    <Route path={baseLocaleUrl + routes.welcome} component={Welcome} />
                    <Route path={baseLocaleUrl + routes.contact} component={Contact} />
                    <Route path={baseLocaleUrl + routes.about} component={About} />
                    <Route path={baseLocaleUrl + routes.login} component={Login} />
                    <Route path={baseLocaleUrl + routes.gdpr} component={GDPR} />
                    <Route path={baseLocaleUrl + routes.rtb} component={RTB} />
                    <Route path={baseLocaleUrl + routes.contextDistanceCalculator} component={ContextDistanceCalculator} />
                    <Redirect to={currentLocale + redirectTo} />
                </Switch>
            </Router>
            {!simple && <Footer {...props} />}

            <Notification />
        </div>
    )
}

export default PageContent


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pageContent.tsx